﻿import { GuiDetailGeneric } from "../../GuiDetailGeneric";

export class GuiDetailStandort extends GuiDetailGeneric {
    constructor() {
        super("Standort");
    }
}
